import Vue from 'vue';
import axios from 'axios'
import { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

const Axios = axios.create()
// Axios.defaults.baseURL = 'http://jiacdz.b.langqiyun.cn/api/';

Axios.interceptors.request.use(config => {
    if (localStorage.getItem('AccessToken')) {
        config.headers.AccessToken = localStorage.getItem('AccessToken')
    }
    if (config.url == '/api/user/getUserInfo' && !localStorage.getItem('AccessToken')) {
        return Promise.reject(false)
    } else {
        return config
    }

})
Axios.interceptors.response.use(response => {
    if (response.data && response.data.status) {
        response.data.status = response.data.status.toUpperCase()
    }
    if (response.data.code == 200 && response.data.status == 'SUCCESS') {
        return response.data
    } else {

        return Promise.reject(response.data)
    }

})
const request = function (url, param) {
    return new Promise((resolve, reject) => {
        url = '/b/api/' + url
        // url = '/api/' + url
        Axios.post(url, param).then(r => {
            resolve(r)
        }).catch(err => {
            Message.error(err.message || '网络错误，请检查网络或稍后再试')
        })
    })

}
export default request